import Terms from '@/api/resources/terms';

const state = {
  terms: null,
};

const getters = {
  getTerms: (state) => state.terms,
};

const actions = {
  getCurrentTerms({ commit }) {
    Terms.current().then((response) => {
      commit('setTerms', response);
    });
  },
};

const mutations = {
  setTerms($state, payload) {
    const stateCopy = $state;
    stateCopy.terms = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
